import React from 'react'

// atomic components
import Section from 'components/atoms/Section'
import SectionItem from 'components/atoms/SectionItem'

// local components
import PickupPerson from './PickupPerson'

const PickupPeople = props => {
  const {
    title,
    account,
    subheaderText,
    buttonText,
    buttonRoute,
    reupRequired,
    setModal,
    editable
  } = props

  return (
    <Section
      title={title}
      subheaderText={subheaderText}
      buttonText={buttonText}
      buttonRoute={buttonRoute}
    >
      {account.parents
        .filter(a => a.pickup)
        .map(adult => (
          <SectionItem key={adult.id}>
            <PickupPerson
              adult={adult}
              type='Parent / Guardian'
              reupRequired={reupRequired}
            />
          </SectionItem>
        ))}
      {account.emergencyContacts
        .filter(a => a.pickup)
        .map(adult => (
          <SectionItem key={adult.id}>
            <PickupPerson adult={adult} type='Emergency Contact' />
          </SectionItem>
        ))}
      {account.pickupPeople.map(adult => (
        <SectionItem key={adult.id}>
          <PickupPerson
            adult={adult}
            type='Pick-up Person'
            reupRequired={reupRequired}
            setModal={setModal}
            editable={editable}
          />
        </SectionItem>
      ))}
    </Section>
  )
}

export default PickupPeople
